import React from 'react';
import { Box, Link } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#f8f9fa',
        padding: '5px 10px',
        borderTop: '1px solid',
        borderColor: 'divider',
        textAlign: 'center',
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        fontSize: '12px',
      }}
    >
      <Link href="https://terminfluss.de/" underline="hover" sx={{ marginX: 1, color: 'text.secondary' }}>
        Terminfluss
      </Link>
      |
      <Link href="https://terminfluss.de/impressum/" underline="hover" sx={{ marginX: 1, color: 'text.secondary' }}>
        Impressum
      </Link>
      |
      <Link href="https://terminfluss.de/datenschutzerklaerung/" underline="hover" sx={{ marginX: 1, color: 'text.secondary' }}>
        Datenschutzerklärung
      </Link>
    </Box>
  );
};

export default Footer;
